import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_layerSoldout} from "../../../../function/FnBodyLayer";
import {fn_quick_cancel} from "../../../../function/FnBodyDetail";

@observer
class OrderRejectView extends Component {

    render() {

        const { rootStore } = this.props;
        const viewStore = rootStore.viewStore;
        const layerStore = rootStore.layerStore;

        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerOrderRejectView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>주문 {rootStore.viewStore.getOrderEndType== "R" ? "거절" : "취소"}사유 선택</h1>
                        </div>
                        <div className="list_radio_reason reject">
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C2");
                                }}
                            ><input type="radio" name="reason" checked={layerStore.getChangeCancelReason==="C2"}
                                    onChange={event => layerStore.setChangeCancelReason('C2')}
                            /><span>가게사정</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C1");
                                }}
                            ><input type="radio" name="reason" checked={layerStore.getChangeCancelReason==="C1"}
                                    onChange={event => layerStore.setChangeCancelReason('C1')}
                            /><span>재료소진</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C0");
                                }}
                            ><input type="radio" name="reason" checked={layerStore.getChangeCancelReason==="C0"}
                                    onChange={event => layerStore.setChangeCancelReason('C0')}
                            /><span>고객요청</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C3");
                                }}
                            ><input type="radio" name="reason" checked={layerStore.getChangeCancelReason==="C3"}
                                    onChange={event => layerStore.setChangeCancelReason('C3')}
                            /><span>요청사항 불가</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C4");
                                }}
                            ><input type="radio" name="reason" checked={layerStore.getChangeCancelReason==="C4"}
                                    onChange={event => layerStore.setChangeCancelReason('C4')}
                            /><span>{rootStore.viewStore.getOrderDetail.orderType == "TABLE" ? "테이블 자리없음" : "배달지연"}</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C5");
                                }}
                            ><input type="radio" name="reason" checked={layerStore.getChangeCancelReason==="C5"}
                                    onChange={event => layerStore.setChangeCancelReason('C5')}
                            /><span>기타</span></label>
                        </div>
                        <div className="list_radio_time ygy">
                            <div className="wrap_full_btn check">
                                <span className="f_l"><button className="btn_cancel"
                                    onClick={event => {
                                        layerStore.setChangeCancelReason("");
                                        layerStore.setLayerOrderReject(false)
                                    }}
                                >취소</button></span>
                                <span className="f_r"><button className="btn_submit"
                                    onClick={event => {
                                        fn_quick_cancel(rootStore);
                                    }}
                                >확인</button></span>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {
                                    layerStore.setChangeCancelReason("");
                                    layerStore.setLayerOrderReject(false)
                                }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderRejectView;